<template>
  <div class="employeeTurnoverList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId1" :placeholder="detail.allHouse">
            <el-option key="0" :label="detail.allHouse" value="0"></el-option>
            <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-button type="primary" @click="topics">{{$t('lang.btn_search')}}</el-button> -->
      </el-form>
    </div>
    <el-card>
      <el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <div class="location">{{$t('lang.lab_forDepartureStaff')}}
          <div style="font-size: 14px; color: #00b1c3;margin-top: 10px;">此操作包括转移：<br>工单状态为处理中、待评价的工单发单人、接单人、封单人；<br>全部状态的计划任务创建人、责任人。</div>
        </div>
        <!-- 离职人员 -->
        <el-form-item :label="$t('lang.lab_departingStaff')" prop="departingStaff">
          <el-select filterable v-model="form.departingStaff" :placeholder="$t('lang.lab_pleSeldepartingStaff')">
            <el-option
              v-for="item in departingStaffs"
              :key="item.id"
              :label="item.idNo"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 转接人员 -->
        <el-form-item :label="$t('lang.lab_forwarder')" prop="transferStaff">
          <el-select filterable v-model="form.transferStaff" :placeholder="$t('lang.lab_pleSelTransferForwarder')">
            <el-option
              v-for="item in Staffs"
              :key="item.id"
              :label="item.idNo"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>         
        <el-button type="primary" class="btn-first" @click="commit('form')">{{$t('lang.btn_handle')}}</el-button>
      </el-form>    
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:employeeTurnoverList
 *@Description:员工离职
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-30
 */
 import {
    mapGetters
  } from 'vuex'
export default {
  data() {
    return {
      form: {
        departingStaff: '', // 离职人员
        transferStaff: '', // 转接人员
      }, 
      rules: {
        departingStaff: [
          {
            required: true, message: this.$i18n.t('lang.lab_pleSeldepartingStaff'), trigger: 'change'
          }         
        ],
        transferStaff: [
          {
            required: true, message: this.$i18n.t('lang.lab_pleSelTransferForwarder'), trigger: 'change'
          }         
        ]       
      }, 
      operStaffId: '', // 账户编号   
      departingStaffs: [], // 离职人员列表     
      Staffs: [], // 转接人员列表 
       tableData: [], // 所有小区存储
      detail: this.$i18n.t('lang.eagleEye'),
      gardenId1: ''
    }
  },
  computed: {
    ...mapGetters(['gardenId'])
  },
  watch: {
    gardenId1(newVal, oldVal) {
        if (newVal != oldVal) {
          this.topics()
        }
      }
    },
  created() {
    this.gardenId1 = this.gardenId
    // 获取此账号id
    this.operStaffId = this.$store.getters.staffId
    this.topics()
    this.gardens()
  },

  methods: {
    gardens() {
        let loading = this.$loading()
        this.$get(`/gardensByStaffId`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
    // 初始化
    topics() {
      this.form.departingStaff = ''
      this.form.transferStaff = ''
      let loading = this.$loading()
      this.$get(`/staffsNoPage?gardenId=${this.gardenId1}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.departingStaffs = res.list
            this.Staffs = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 办理
    commit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.departingStaff === this.form.transferStaff) {
            this.$message.error(this.$i18n.t('lang.lab_DepartStaffCannotSome'))            
          } else {
              let params = {
              leaveAdminId: this.form.departingStaff,
              receiveAdminId: this.form.transferStaff,
              operStaffId: this.operStaffId,
            }
            let loading = this.$loading()
            this.$patch('/leaveHandle', params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_departingStaffHandleSuc'))
                  this.topics()
                  this.form.departingStaff = ''
                  this.form.transferStaff = ''
                  setTimeout(() => {
                      this.$refs.form.clearValidate()
                    }, 0)
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )           
          }                           
        }
      })      
    }    
  }
}
</script>

<style lang="scss">
.employeeTurnoverList{
  .location{
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 20px;
    font-size: 20px;
  }
}
</style>